export const ResumeEducationLevel = {
  HighSchool: 1,
  Undergraduate: 2,
  PostGraduate: 3,
};
